import { FactoringCompany } from '@store/carriers';
import { setFactoringCompanyDetailsChangeBaseline } from '@changeTracking/pages/factoringCompanyDetails/formChangeTracking';
import {
  fetchCustomerFactoringCompanyDetails,
  fetchFactoringCompanyDetailsDocuments,
} from '@store/factoringCompany/factoringCompanyDetails/services';
import { produce } from 'solid-js/store';

import { setFactoringCompanyDetailsStore } from './store';

export const getFactoringCompanyData = async (id: string) => {
  setFactoringCompanyDetailsStore('isLoading', true);

  const resp = await fetchCustomerFactoringCompanyDetails(id);
  if (resp?.isSuccess) {
    const factoringCompanyDetails = resp.value as FactoringCompany;
    setFactoringCompanyDetailsStore(
      produce((draft) => {
        draft.factoringCompanyDetails = factoringCompanyDetails;
        draft.isError = false;
        draft.isLoading = false;
      }),
    );
    setFactoringCompanyDetailsChangeBaseline(factoringCompanyDetails);
  } else {
    setFactoringCompanyDetailsStore('isLoading', false);
    setFactoringCompanyDetailsStore(
      produce((draft) => {
        draft.isError = true;
        draft.factoringCompanyDetails = {} as FactoringCompany;
      }),
    );
  }
};

export const updateFactoringCompanyDetailsState = (
  updates: Partial<FactoringCompany>,
) => {
  Object.entries(updates).forEach(([key, value]) => {
    setFactoringCompanyDetailsStore(
      'factoringCompanyDetails',
      key as keyof FactoringCompany,
      value,
    );
  });
};

export const getFactoringCompanyDetailsDocuments = async (id: string) => {
  setFactoringCompanyDetailsStore('isDocumentsLoading', true);
  const resp = await fetchFactoringCompanyDetailsDocuments(id);
  resp
    ? setFactoringCompanyDetailsStore('documents', resp)
    : setFactoringCompanyDetailsStore('documents', []);
  setFactoringCompanyDetailsStore('isDocumentsLoading', false);
};
